import * as MC from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

export const FilterSearchButton = (props: MC.ActionIconProps) => {
  return (
    <MC.ActionIcon type="submit" {...props}>
      <IconSearch />
    </MC.ActionIcon>
  );
};
